<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a href="/admin/accountOwnerList/">Account Owners</a></li>
      <li class="breadcrumb-item active" aria-current="page">Payment Processing</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <h2 class="text-white mb-3"></h2>
        <div class="inner-box">
          <div class="row mt-2">
            <div class="col-md-4">
              <label><b>Date</b></label>
              <input type="date" class="form-control" [(ngModel)]="paymentDate" (blur)="blurDate()"
              [ngModelOptions]="{standalone: true}">
              <div id="statusText1" class="invalid-feedback d-block mb-3" [hidden]="!statusText1">{{statusText1}}</div>
            </div>
            <div class="col-md-4">
              <label><b>Paid By</b></label>
              <input type="text" class="form-control" [(ngModel)]="paidBy" (blur)="blurPaymentDoneBy()"
              [ngModelOptions]="{standalone: true}">
              <div id="statusText2" class="invalid-feedback d-block mb-3" [hidden]="!statusText2">{{statusText2}}</div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4 required">
              <label class="control-label"><b>Select Payment Type</b></label>
              <ng-select style="height: 38px" id="paymentMode" [(ngModel)]="selectedPaymentMode" (click)="reset()"
                         [ngModelOptions]="{standalone: true}"
                         required
                         [ngClass]="{'service-error':statusText1}"
                         (blur)="blurPayment()"
                         [ngClass]="{'is-invalid':statusText1}"
                         [items]="paymentMode"
                         bindLabel="config"
                         placeholder="Payment Mode">
              </ng-select>
              <div id="statusText3" class="invalid-feedback d-block mb-3" [hidden]="!statusText3">{{statusText3}}</div>
            </div>
            <div class="col-md-4" [hidden]="selectedPaymentMode.config !== 'CHEQUE'">
              <label for="chequeNum"><b>Cheque Number</b></label>
              <div class="form-group">
                <input type="text" id="chequeNum" [(ngModel)]="chequeNum" (click)="reset()" (blur)="blurNumber()"
                       [ngModelOptions]="{standalone: true}" class="form-control" required>
              </div>
            </div>
            <div class="col-md-4" [hidden]="selectedPaymentMode.config !== 'BANK_TRANSFER'">
              <label for="refNum"><b>Reference Number</b></label>
              <div class="form-group">
                <input type="text" id="refNum" [(ngModel)]="refNum" (click)="reset()" (blur)="blurNumber()"
                       [ngModelOptions]="{standalone: true}" class="form-control" required>
              </div>
            </div>
            <div class="col-md-4" [hidden]="selectedPaymentMode.config !== 'CASH'">
              <label for="receiptNum"><b>Receipt Number</b></label>
              <div class="form-group">
                <input type="text" id="receiptNum" [(ngModel)]="receiptNum" (click)="reset()" (blur)="blurNumber()"
                       [ngModelOptions]="{standalone: true}" class="form-control" required>
                <div id="statusText4" class="invalid-feedback d-block mb-3" [hidden]="!statusText4">{{statusText4}}</div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <label><b>Amount :</b></label>
              <input class="form-control" [(ngModel)]="totalAmount" (blur)="blurAmount()"
              [ngModelOptions]="{standalone: true}">
              <div id="statusText5" class="invalid-feedback d-block mb-3" [hidden]="!statusText5">{{statusText5}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="row mt-4">
    <div class="form-btn-section" style="margin-left: -15px;">
      <div class="col-12 text-right">
        <button type="button" routerLink="/admin/accountOwnersList" class="btn btn-cancel">Close</button>
        <button type="button" (click)="processingPayment()" class="btn btn-orange ml-2">Confirm</button>
      </div>
    </div>
  </div>
</section>
